import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Link, useParams } from "react-router-dom";
import { Formik } from "formik";
import { connect, useDispatch, useSelector } from "react-redux";
import { updateManageCatList } from "../../redux/action/checklists";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import NoImage from "../../assets/images/noimages.jpg";
import { GetCatById } from "../../redux/action/checklists";
const initialState = { alt: "", src: "" };

const EditCategory = () => {
  const paramId = useParams();

  const dispatch = useDispatch();
  const SignupSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    Detail: Yup.string().required("Details is required"),
  });
  const [activeLoader, setActiveLoader] = useState(false);
  const [{ alt, src }, setPreview] = useState(initialState);
  const getCheckDetails = useSelector((state) => state?.checklists?.list);

  const checkDetails = getCheckDetails?.data
    ? getCheckDetails?.data?.checklistparent
    : "";
  const [img, setImg] = useState(checkDetails?.image);

  const fileHandler = (event) => {
    const { files } = event.target;
    var formdata = new FormData();
    formdata.append("image", event.target.files[0]);

    const token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/image`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("result", result)
        if (result.status == "success") {
          setPreview({
            src: APIURL + "/" + result?.data?.images?.image
          })
          setActiveLoader(false);
          setImg(result.data.images.image);
        }
      })
      .catch((error) => console.log("error", error));
    setActiveLoader(true);
  };
  console.log("src", src);
  useEffect(() => {
    dispatch(GetCatById(paramId?._id));
  }, [dispatch, paramId?._id], getCheckDetails);

  const imageSource =  src ? src : checkDetails?.image ? (APIURL + "/" + checkDetails?.image) : NoImage;

  
  return (
    <React.Fragment>
      <Layout title="Edit Category" page="edit-category">
        <ToastContainer autoClose={2000} />
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <div className="card-title">
                      <span className="svg-icon svg-icon-1 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                            fill="black"
                          ></path>
                          <path
                            opacity="0.3"
                            d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      <h2>Edit Category</h2>
                    </div>
                  </div>
                  <div className="card-body pt-5">
                    <Formik
                      initialValues={{
                        name: checkDetails?.name ? checkDetails?.name : "",
                        Detail: checkDetails?.Detail
                          ? checkDetails?.Detail
                          : "",
                        image: checkDetails?.image ? checkDetails?.image : "",
                      }}
                      enableReinitialize={true}
                      validationSchema={SignupSchema}
                      onSubmit={(values) => {
                        values.name = values?.name
                          ? values?.name
                          : checkDetails?.name;
                        values.Detail = values?.Detail
                          ? values?.Detail
                          : checkDetails?.Detail;
                        if (img) {
                          values.image = img;
                        } else {
                          values.image = checkDetails?.image;
                        }
                        dispatch(updateManageCatList(values, paramId?._id));
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                      }) => (
                        <form className="form" onSubmit={handleSubmit}>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Checklist picture
                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div
                                className="image-input w-125px h-125px image-input-outline"
                                data-kt-image-input="true"
                                style={{
                                  backgroundImage: `url(${imageSource})`,
                                }}
                              >
                                <label
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                  data-kt-image-input-action="change"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Change avatar"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                  </svg>
                                  <input
                                    id="file-input"
                                    accept="image/*"
                                    type="file"
                                    onChange={fileHandler}
                                  />
                                  <input type="hidden" name="avatar_remove" />
                                </label>
                                <span
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                  data-kt-image-input-action="cancel"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="Cancel avatar"
                                >
                                  <i className="bi bi-x fs-2"></i>
                                </span>
                                {activeLoader == true ? (
                                  <div
                                    className="d-flex align-items-center justify-content-center h-100"
                                    style={{ background: "#e2e2e270" }}
                                  >
                                    <div
                                      className="spinner-border w-80"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="form-text">
                                Allowed file types: png, jpg, jpeg.
                              </div>
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Name</span></div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                className="form-control form-control-solid"
                                name="name"
                                id="name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                defaultValue={values.name}
                              />
                              {errors.name && touched.name ? (
                                <div className="text-danger mt-2">
                                  {errors.name}
                                </div>
                              ) : null}
                              <div className="fv-plugins-message-container invalid-feedback"></div>
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-3">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                <span className="required">Details</span>
                              </div>
                            </div>
                            <div className="col-xl-9 fv-row fv-plugins-icon-container">
                              <textarea
                                type="text"
                                className="form-control form-control-solid"
                                name="Detail"
                                id="Detail"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                defaultValue={values.Detail}
                              ></textarea>

                              {errors.Detail && touched.Detail ? (
                                <div className="text-danger mt-2">
                                  {errors.Detail}
                                </div>
                              ) : null}
                              <div className="fv-plugins-message-container invalid-feedback"></div>
                            </div>
                          </div>
                          <div className="separator mb-6"></div>
                          <div className="d-flex justify-content-end">
                            <Link
                              to="/manage-checklists"
                              type="reset"
                              className="btn btn-light me-3"
                            >
                              Cancel
                            </Link>
                            <button type="submit" className="btn btn-primary">
                              <span className="indicator-label">Save</span>
                            </button>
                          </div>
                          <div></div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default connect(null, { updateManageCatList })(EditCategory);
